import type { ReactNode } from 'react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader } from './components/Loader';
import { useAuth } from './hooks/useAuth';

interface AuthWrapperProps {
	children: ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
	const { user, loading } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		if (!loading && !user) {
			navigate('/login', { replace: true });
		}
	}, [loading, user, navigate]);

	if (loading) {
		return <Loader />;
	}

	if (user) {
		return children ? <>{children}</> : <></>;
	}

	// Optionally, render nothing while redirecting
	return null;
};

export { AuthWrapper };
